import { useTranslation } from '@klv/hooks/useTranslation';

import * as s from './styles';
import type { ISubcategoryCard } from './types';

const SubcategoryCard = ({
  articleCount,
  link,
  headlineVariant = 'paragraph2Semibold',
  description,
  name,
  ...props
}:  ISubcategoryCard) => {
  const { t } = useTranslation();

  if (articleCount && articleCount < 1) return null;

  return (
    <s.StyledSubcategoryCard to={link} {...props}>
      <s.Name colorVariant="dark" variant={headlineVariant}>{name}</s.Name>
      {!!description && <s.Description colorVariant="dark" variant="paragraph2">{description}</s.Description>}
      {articleCount && 
        <s.ArticleCount colorVariant="dark" variant="paragraph2">{`${articleCount} ${articleCount > 1 ? t('molecules_subcategoryCard_articlesPlural') : t('molecules_subcategoryCard_articleSingular')}`}</s.ArticleCount>
      }
    </s.StyledSubcategoryCard>
  );
};

export default SubcategoryCard;
